import {
  Button,
  Card,
  Skeleton,
  DatePicker,
  Spin,
  Checkbox,
  ConfigProvider,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  generatedISOFormatDateString,
  groupDataByInterval,
  groupDataByIntervalElectrical,
} from "../../../../../../Utils/DateConverstion";

import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
import TreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import { useSelector } from "react-redux";
import TreeSelectCustom from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import * as echarts from "echarts";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { FilterOutlined } from "@ant-design/icons";
import Empty from "../../../../../CommonScreens/Empty";
const { RangePicker } = DatePicker;
// import dayjs from "dayjs";
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import SteamTreeSelectCustom from "../../../../../Elements/TreeSelect/TreeSelectCustom";

// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
 

const ComparitiveReport = () => {
  const chartRef = useRef(null);
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(null);
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState(null);
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState(null);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [aggregationTime, setAggregationtime] = useState(null);

  const [aggeregationResData, setaggeregationResData] = useState([]);
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [aggregationError, setAggregationError] = useState();
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState(
    []
  );
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] =
    useState([]);
  const [data, setData] = useState([]);
  const [parameter, setParameter] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [loadings, setLoadings] = useState(true);
  const [parameterLenght, setParameterLenght] = useState("");
  const [to, setTo] = useState(null);
  const [from, setFrom] = useState(null);

  const [checkedValue, setCheckedValue] = useState(null);
  const [time, setTime] = useState(false);
  const [shift, setShift] = useState(null);
  

  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); // 2 seconds
  };
  useEffect(() => {
    simulateLoading(setLoadings);
  }, []);

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  console.log(color)

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if(res&&res.length>0){
          
        setflowSectionResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if(res&&res.length>0){
          
        setgetFlowConverterResData(res);
      }
    });

    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
    }).then((res) => {
      console.log(res);if(res&&res.length>0){
          
        setflowGroupDetailsResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,

      url: `${APIConstants.GET_STEAM_AGGREGATION_PERIOD}`,
    }).then((res) => {
      console.log(res);
      if(res&&res.length>0){
          
        setaggeregationResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_HISTORICAL_PARAMETERS_LIST}`,
    }).then((res) => {
      console.log(res);
      if(res&&res.length>0){
          
        setParameter(res);
      }
    });
  }, []);

  useEffect(() => {
    if (converterGroupId) {
      makeRequest({
        type: APIConstants.GET,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        console.log(res);
        if(res&&res.length>0){
          
          setnsGetFlowConverterResData(res);
        }
      });
    }

    makeRequest({
      type: APIConstants.POST,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`,
      // url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}`
    }).then((res) => {
      console.log(res);
      if(res&&res.length>0){
          
        setgetFlowSteamGroupMeterResData(res);
      }
    });
  }, [converterGroupId]);

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];
  const aggeregationList = (aggeregationResData && aggeregationResData) || [];

  const handleChangeAggregation = (value) => {
    console.log(value);
    setAggregationtime(value);
    setToDateError(null);
    setFromDateError(null);
    setValue([null,null])
    if (value) {
      setAggregationError("");
    }
  };

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setConverterGroupId();
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    console.log(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };



  const onChangeFromDate = ( dateString) => {
    console.log(dateString);
    console.log(new Date(dateString));
    setFromDateString(dateString);
    setFromDateObj(dateString);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = ( dateString) => {
    setToDateString(dateString);
    setToDateObj(dateString);
    if (dateString) {
      setToDateError("");
    }
  };

  const getResponse = (inputData) => {
    console.log(inputData);

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_COMPARATIVE_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
      // url: `${APIConstants.ELECTRICAL_COMPARATIVE_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=2023-08-13 11:32:53.927&ToDate=2023-08-13 12:32:53.927`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setData(res);
        timePeriod(res);
      } else {
        setData([]);
      }
    })
    // .then(data => {
    //   const totalKWHTotal = data.reduce((sum, item) => sum + (item.KWHTotal || 0), 0);
    //   console.log("Total KWHTotal:", totalKWHTotal);
    // });
  };

  const timePeriod = (data) => {
    const fromDate = new Date(fromDateString);
    const toDate = new Date(toDateString);

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    const formattedFromDate = generatedISOFormatDateString(fromDate);
    const formattedToDate = generatedISOFormatDateString(toDate);

    const aggregationName = aggeregationResData.find(
      (aggregation) => aggregation.aggregationPeriodID === aggregationTime
    ).aggregationPeriodName;

    const period =
      aggregationName === "15Mins"
        ? "min"
        : aggregationName === "60Min Report"
          ? "min"
          : aggregationName === "24Hours Report"
            ? "day"
            : aggregationName === "Monthly Report"
              ? "month"
              : "min";

    const interval =
      aggregationName === "15Mins"
        ? 15
        : aggregationName === "60Min Report"
          ? 60
          : aggregationName === "24Hours Report"
            ? 1
            : aggregationName === "Monthly Report"
              ? 1
              : 480;

    console.log(data);
    console.log(interval);
    console.log(period);
    console.log(fromDate);
    console.log(toDate);
    const seriesData = groupDataByIntervalElectrical(
      data,
      interval,
      period,
      fromDate,
      toDate,
      selectedValues
    );
    console.log(seriesData);

    const input = seriesData?.chartArray;
    console.log("first");
    console.log(input);

    const inputArr = input;
    const dateArray = seriesData?.firstRecordCreatedONArray;
    console.log(dateArray);
    console.log(inputArr);
    const series = inputArr.map((key, index) => ({
      name: key.name,
      type: "bar",
      emphasis: {
        focus: "series",
      },
      data: key.data,
      date: dateArray,
    }));
    console.log(series);

    setData1(dateArray);
    setData2(series);
  };

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const validateToDateInput = (
    toDateValue,
    fromDateValue,
    aggregationPeriod,
    label
  ) => {
    switch (aggregationPeriod) {
      case 1: {
        // Validate if the time difference is a multiple of 15 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % 15 === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 15 minutes for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 1 hour for ${label}`;
        }

        return error;
      }
      case 2: {
        // Validate if the time difference is a multiple of 60 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % 60 === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 8 * 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 60 minutes for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 8 hours for ${label}`;
        }

        return error;
      }
      case 3: {
        // Validate if the time difference is a multiple of 60 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 24) === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 7 * 24 * 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 24 hours for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 1 week for ${label}`;
        }

        return error;
      }
      case 4: {
        // Validate if the time difference is a multiple of 60 minutes
        const fromDate = new Date(fromDateValue);
        const toDate = new Date(toDateValue);

        const monthsDifference =
          (toDate.getUTCFullYear() - fromDate.getUTCFullYear()) * 12 +
          (toDate.getUTCMonth() - fromDate.getUTCMonth());

        // Calculate the year and month difference

        const isMultipleOf15Minutes = monthsDifference % 1 === 0; // Check if it's a whole number of months
        const isAtLeast6Months = monthsDifference >= 2;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 1 month for ${label}`;
        } else if (!isAtLeast6Months) {
          error = `Minimum time difference must be 2 month for ${label}`;
        }

        return error;
      }
      case 5: {
        // Validate if the time difference is a multiple of 60 minutes
        const timeDifferenceInMilliseconds =
          new Date(toDateValue).getTime() - new Date(fromDateValue).getTime();
        const timeDifferenceInMinutes =
          timeDifferenceInMilliseconds / (1000 * 60);

        const isMultipleOf15Minutes = timeDifferenceInMinutes % (60 * 8) === 0;
        const isAtLeast1Hour = timeDifferenceInMinutes >= 24 * 60;

        let error = "";
        if (!isMultipleOf15Minutes) {
          error = `Time difference must be a multiple of 8 hours for ${label}`;
        } else if (!isAtLeast1Hour) {
          error = `Minimum time difference must be 1 day for ${label}`;
        }

        return error;
      }
      default: {
        // Handle invalid aggregation period
        return `Invalid aggregation period: ${aggregationPeriod}`;
      }
    }
  };

  const handleSubmit = async () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");
    const paraError = validateInput(selectedValues?.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateToDateInput(
      toDateString,
      fromDateString,
      aggregationTime,
      "From Date"
    );
    const aggregationError = validateInput(aggregationTime, "Aggregation");

    console.log(fromDateString)
    console.log(paraError)
    console.log(selectedValues)
    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);
    setAggregationError(aggregationError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError &&
      !aggregationError
    ) {
      onClose();

      const ids = selectedMeterIds?.map((id) => id).join(",");
      const para = selectedValues?.map((id) => id).join(",");

      const fromDate = new Date(fromDateString);
      const toDate = new Date(toDateString);

      const fromHours = fromDate.getUTCHours();
      const fromMinutes = fromDate.getUTCMinutes();
      const fromSeconds = fromDate.getUTCSeconds();

      const toHours = toDate.getUTCHours();
      const toMinutes = toDate.getUTCMinutes();
      const toSeconds = toDate.getUTCSeconds();

      // Set the UTC hours, minutes, and seconds
      fromDate.setUTCHours(fromHours);
      fromDate.setUTCMinutes(fromMinutes);
      fromDate.setUTCSeconds(fromSeconds);

      toDate.setUTCHours(toHours);
      toDate.setUTCMinutes(toMinutes);
      toDate.setUTCSeconds(toSeconds);

      const formattedFromDate = generatedISOFormatDateString(fromDate);
      const formattedToDate = generatedISOFormatDateString(toDate);
      console.log(formattedFromDate)

      try {
        const inputData = {
          SectionID: Number(sectionId) || 0,
          ConverterorGroupID: Number(converterGroupId) || 0,
          MeterIds: ids || ["0"],
          Parameters: para || ["0"],
          FromDate: formattedFromDate || "2023-09-21T15:52:20.000Z",
          ToDate: formattedToDate || "2023-09-21T15:58:20.000Z",
        };
        console.log(inputData);

        setIsLoading(true);
        getResponse(inputData);

        console.log("first data");
        console.log(data);
        console.log(aggeregationResData);

        const aggregationName = aggeregationResData.find(
          (aggregation) => aggregation.aggregationPeriodID === aggregationTime
        ).aggregationPeriodName;

        const period =
          aggregationName === "15Mins"
            ? "min"
            : aggregationName === "60Min Report"
              ? "min"
              : aggregationName === "24Hours Report"
                ? "day"
                : aggregationName === "Monthly Report"
                  ? "month"
                  : "min";

        const interval =
          aggregationName === "15Mins"
            ? 15
            : aggregationName === "60Min Report"
              ? 60
              : aggregationName === "24Hours Report"
                ? 1
                : aggregationName === "Monthly Report"
                  ? 1
                  : 480;

        const seriesData = groupDataByInterval(
          data,
          interval,
          period,
          fromDate
        );

        const input = seriesData?.chartArray;

        const inputArr = input;
        const dateArray = seriesData?.firstRecordCreatedONArray;
        console.log(dateArray);
        console.log(inputArr);
        setData1([]);
        setData2([]);
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values.length > 4) {
      console.log(values);
      setParameterLenght("Cannot select more than 4 values");
    } else {
      setParameterLenght("");
    }
    if (values) {
      setParaError("");
    }
  };

  useEffect(() => {
    if (loading || !data1 || !data2) return;

    console.log(data1);
    console.log(data2); 

    const myChart = echarts.init(chartRef.current);

    const option = {
      backgroundColor: isdarkMode ? '#2d3748' : "#fff",
      // title: {
      //   text: `Comparative Report`,
      //   left: 'center',
      //   top: '5px',
      //   textStyle: {
      //     color: isdarkMode ? 'white' : 'black',
      //   },
      // },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        confine: true,
        position: function (point, params, dom, rect, size) {
          // `point` is the mouse position, `[x, y]`
          // `size` contains the size of the tooltip
          const [x, y] = point;
          const { contentSize, viewSize } = size; // Size of the tooltip and view

          let xPos = x + 10; // Add padding to the right
          let yPos = y + 10; // Add padding to the bottom

          // Prevent overflow on the right
          if (xPos + contentSize[0] > viewSize[0]) {
            xPos -= contentSize[0] + 20; // Move it left if it overflows
          }

          // Prevent overflow on the left
          if (xPos < 0) {
            xPos = 10; // Reset to a small margin on the left
          }

          // Prevent overflow at the bottom
          if (yPos + contentSize[1] > viewSize[1]) {
            yPos -= contentSize[1] + 20; // Move it up if it overflows
          }

          // Prevent overflow at the top
          if (yPos < 0) {
            yPos = 10; // Reset to a small margin at the top
          }

          return [xPos, yPos];
        },
      },

      legend: {
        bottom: "0px",
        textStyle: {
          color: isdarkMode ? "white" : "black",
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "15%",
        containLabel: true,
      },
      toolbox: {
        show: true,
        orient: "horizontal",
        left: "right",
        top: "top",

        feature: {
          myExport: {
            show: true,
            title: "Export to Excel",
            icon: "path://M5 0L15 10L5 20Z", // Custom arrow-like icon
            onclick: () => {
              exportToExcel(data2);
            },
          },
          mark: { show: true },
          magicType: { show: true, type: ["line", "bar"] },
          saveAsImage: { show: true },
        },
        iconStyle: {
          borderColor: isdarkMode ? "white" : "black", // Change icon color based on theme
        },
        emphasis: {
          iconStyle: {
            borderColor: isdarkMode ? "#FFD700" : "#1E90FF", // Highlighted color on hover
          },
        },
      },
      xAxis: [
        {
          type: "category",
          data: Array.from({ length: 8 }, (_, i) => `S. No.${i + 1}`),
          axisTick: { show: false },
          data: data1,
          axisLabel: {
            color: isdarkMode ? "white" : "black",
            fontSize: "10",
            rotate: 90,
            fontWeight: "bold",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          axisLabel: {
            color: isdarkMode ? "white" : "black",
            fontSize: "10",
            fontWeight: "bold",
          },
        },
      ],
      series: data2,
      dataZoom: [
        {
          type: "inside", // Enables zooming via scroll or pinch
          start: 0,
          end: 100,
        },
      ],
    };

    myChart.setOption(option);

    const resizeHandler = () => myChart.resize();
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
      myChart.dispose();
    };
  }, [data1, data2, isdarkMode, loading,color]);

  console.log(data1);
  console.log(data2);

  console.log(loading);

  const handleTimeRangeChange = (value) => {
    const now = dayjs(); // Current time using Day.js for formatting
    let fromTime;

    switch (value) {
      case "60min":
        fromTime = now.subtract(60, "minute");
        break;
      case "8hours":
        fromTime = now.subtract(8, "hour");
        break;
      case "7days":
        fromTime = now.subtract(7, "day");
        break;
      case "30days":
        fromTime = now.subtract(30, "day");
        break;
      case "90days":
        fromTime = now.subtract(90, "day");
        break;
      case "24hours":
        fromTime = now.subtract(1, "day");
        break;
      default:
        fromTime = null;
    }

    console.log("From:", fromTime);
    console.log("To:", now);
    // Format the dates into a string compatible with DatePicker
    const fromTimeString = fromTime
      ? fromTime.format("YYYY-MM-DD HH:mm:ss")
      : null;
    const toTimeString = now.format("YYYY-MM-DD HH:mm:ss");
    console.log("From:", fromTimeString);
    console.log("To:", toTimeString);
    // console.log(fromTime)
    // 2024-11-08 00:00:00
    // 2024-11-20 16:05:57
    setToDateObj(null);
    setFromDateObj(null);

    // Optionally, you can return these values or set them in state
    // return { fromTimeString, toTimeString };
    console.log(time);
    console.log(checkedValue);
    // if(checkedValue){
    //   setFromDateString(null)
    //   setToDateString(null)
    // }else{
    setFromDateString(fromTimeString);
    setToDateString(toTimeString);
    // }
    setFrom(fromTimeString);
    setTo(toTimeString);
  };

  useEffect(() => {
    setFromDateString(null);
    setToDateString(null);
    setToDateObj(null);
    setFromDateObj(null);
    setTime(false);
    setCheckedValue(null);
  }, [aggregationTime]);

  // const exportToExcel = (data) => {

  //   console.log(data);
  //   console.log(shift);

  //   if (shift === '24hours') {
  //     const headers = ["Meter", "Time", "Shift1", "Shift2", "Shift3", "Total Energy", "Parameter"];
  //     const rows = [];
  //     let totalShift1 = 0, totalShift2 = 0, totalShift3 = 0, totalEnergy = 0;

  //     data.forEach((item, index) => {
  //         const toDate = new Date(item.date[item.date.length - 1]);
  //         const formattedToDate = toDate.toLocaleString("en-GB", {
  //             day: "2-digit",
  //             month: "2-digit",
  //             year: "numeric",
  //             hour: "2-digit",
  //             minute: "2-digit",
  //             second: "2-digit",
  //             hour12: true,
  //         });

  //         const fromDate = new Date(toDate);
  //         fromDate.setDate(fromDate.getDate() - 1);
  //         const formattedFromDate = fromDate.toLocaleString("en-GB", {
  //             day: "2-digit",
  //             month: "2-digit",
  //             year: "numeric",
  //             hour: "2-digit",
  //             minute: "2-digit",
  //             second: "2-digit",
  //             hour12: true,
  //         });

  //         const timeRange = `From : ${formattedFromDate} To : ${formattedToDate}`;
  //         const shift1 = item.data[0] || 0;
  //         const shift2 = item.data[1] || 0;
  //         const shift3 = item.data[2] || 0;
  //         const total = shift1 + shift2 + shift3;

  //         totalShift1 += shift1;
  //         totalShift2 += shift2;
  //         totalShift3 += shift3;
  //         totalEnergy += total;

  //         rows.push([
  //             index + 1, // Meter number
  //             timeRange,
  //             shift1,
  //             shift2,
  //             shift3,
  //             total,
  //             "KWHTOTAL"
  //         ]);
  //     });

  //     // Add total row
  //     rows.push([
  //         "Total",
  //         "",
  //         totalShift1,
  //         totalShift2,
  //         totalShift3,
  //         totalEnergy,
  //         ""
  //     ]);

  //     const excelData = [headers, ...rows];

  //     const workbook = XLSX.utils.book_new();
  //     const worksheet = XLSX.utils.aoa_to_sheet(excelData);
  //     XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");

  //     const now = new Date();
  //     const timestamp = now.toLocaleString("en-US", {
  //         year: "numeric", month: "2-digit", day: "2-digit",
  //         hour: "2-digit", minute: "2-digit", second: "2-digit",
  //         hour12: false,
  //     }).replace(/[/,: ]/g, "-");

  //     const filename = `Comparative_Report_${timestamp}.xlsx`;
  //     XLSX.writeFile(workbook, filename);
  // }

  // };
  const exportToExcelS = (data) => {
    console.log(data);
    console.log(shift);

    if (shift === "24hours") {
      const headers = [
        "Meter",
        "Time",
        "Shift1",
        "Shift2",
        "Shift3",
        "Total Energy",
        "Parameter",
      ];
      const rows = [];
      let totalShift1 = 0,
        totalShift2 = 0,
        totalShift3 = 0,
        totalEnergy = 0;

      data.forEach((item, index) => {
        const toDate = new Date(item.date[item.date.length - 1]);
        const formattedToDate = toDate.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const fromDate = new Date(toDate);
        fromDate.setDate(fromDate.getDate() - 1);
        const formattedFromDate = fromDate.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const timeRange = `From : ${formattedFromDate} To : ${formattedToDate}`;
        const shift1 = item.data[0].value || 0;
        const shift2 = item.data[1].value || 0;
        const shift3 = item.data[2].value || 0;
        const total = shift1 + shift2 + shift3;

        totalShift1 += shift1;
        totalShift2 += shift2;
        totalShift3 += shift3;
        totalEnergy += total;

        rows.push([
          index + 1, // Meter number
          timeRange,
          shift1,
          shift2,
          shift3,
          total,
          "KWHTOTAL",
        ]);
      });

      // Add total row
      rows.push([
        "Total",
        "",
        totalShift1,
        totalShift2,
        totalShift3,
        totalEnergy,
        "",
      ]);

      const excelData = [headers, ...rows];

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(excelData);
      XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");

      const now = new Date();
      const timestamp = now
        .toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(/[/,: ]/g, "-");

      const filename = `Comparative_Report_${timestamp}.xlsx`;
      XLSX.writeFile(workbook, filename);
    } else {
      console.log(data);
      if (typeof XLSX === "undefined") {
        throw new Error(
          "SheetJS (XLSX) library is required for this function."
        );
      }

      // Helper function to parse dates
      const parseDate = (dateString) => new Date(dateString);

      // Helper function to format dates
      const formatDate = (date) => {
        return date.toLocaleString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
      };

      // Step 1: Calculate intervals dynamically based on the first two timestamps
      const firstMeter = data[0];
      const startTime = parseDate(firstMeter.date[0]);
      const secondTime = parseDate(firstMeter.date[1]);
      const endTime = parseDate(firstMeter.date[firstMeter.date.length - 1]);

      // Calculate the interval in minutes
      const intervalInMinutes = Math.round(
        (secondTime - startTime) / (60 * 1000)
      );

      const intervals = [];
      let currentTime = new Date(
        startTime.getTime() - intervalInMinutes * 60 * 1000
      ); // Start exactly from the first timestamp

      while (currentTime <= endTime) {
        // Ensure intervals include the last timestamp
        const nextTime = new Date(
          currentTime.getTime() + intervalInMinutes * 60 * 1000
        );
        intervals.push({
          from: formatDate(currentTime),
          to: formatDate(nextTime),
          startTime: new Date(currentTime), // Raw date for comparison
          endTime: new Date(nextTime), // Raw date for comparison
        });
        currentTime = nextTime;
      }

      // Step 2: Create headers for Excel
      const headers = [
        "From Date",
        "To Date",
        ...data.map((item) => item.name),
        "Parameter",
      ];

      // Step 3: Populate rows with data for each interval
      const rows = [];
      rows.push(headers); // Add headers as the first row

      const totals = {}; // Store totals for each meter
      data.forEach((item) => (totals[item.name] = 0)); // Initialize totals
      console.log(data);

      intervals.pop();
      intervals.forEach((interval, index) => {
        const row = [interval.from, interval.to]; // Add interval details
        console.log(intervals);

        data.forEach((item) => {
          // Find the first matching date for the interval
          // const dateIndex = item.date.findIndex(
          //   (date) =>
          //     parseDate(date) <= interval.endTime
          // );
          // const dateIndex = item.date.findIndex(
          //   (date) =>
          //     parseDate(date) >= interval.startTime && parseDate(date) < interval.endTime
          // );

          // Include the first value for the first interval
          const value = index !== -1 ? item.data[index].value : 0; // Default to 0 if no matching data
          row.push(value);

          // Update totals
          totals[item.name] += value;
        });
        row.push(selectedValues.toString());
        rows.push(row); // Add the interval row to the sheet
      });

      // Step 4: Add a total row
      const totalRow = [
        "Total",
        "",
        ...data.map((item) => totals[item.name] || 0),
      ];
      rows.push(totalRow);

      // Step 5: Create Excel file using SheetJS
      const workbook = XLSX.utils.book_new(); // Create a new workbook
      const worksheet = XLSX.utils.aoa_to_sheet(rows); // Convert rows to a worksheet
      XLSX.utils.book_append_sheet(workbook, worksheet, "Interval Report"); // Append worksheet to workbook

      // Step 6: Generate filename with timestamp
      const now = new Date();
      const timestamp = now.toISOString().replace(/[-:T]/g, "_").split(".")[0];
      const filename = `Comparative_Report${timestamp}.xlsx`;

      // Step 7: Write the Excel file
      XLSX.writeFile(workbook, filename);
    }
  };
    const exportToExcel = (data) => {
  console.log(data);
  console.log(shift);

  const roundToTwo = (num) => Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;

  if (shift === "24hours") {
    const headers = ["Meter", "Time", "Shift Value", "Parameter"];
    const rows = [];
    let totalEnergy = 0;

    data.forEach((item, meterIndex) => {
      const meterName = item.name || `Meter ${meterIndex + 1}`;

      item.data.forEach((entry) => {
        const fromDate = new Date(entry.intervalRange?.start);
        const toDate = new Date(entry.intervalRange?.end);

        const formattedFromDate = fromDate.toLocaleString("en-GB", {
          day: "2-digit", month: "2-digit", year: "numeric",
          hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
        });

        const formattedToDate = toDate.toLocaleString("en-GB", {
          day: "2-digit", month: "2-digit", year: "numeric",
          hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
        });

        const timeRange = `From: ${formattedFromDate} To: ${formattedToDate}`;
        const value = parseFloat(entry.value || 0);
        totalEnergy += value;

        rows.push([
          meterName,
          timeRange,
          roundToTwo(value),
          selectedValues?.toString() || "",
        ]);
      });
    });

    // Add total row with rounded total
    rows.push([
      "Total",
      "",
      roundToTwo(totalEnergy),
      "",
    ]);

    const excelData = [headers, ...rows];

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");

    const now = new Date();
    const timestamp = now.toLocaleString("en-US", {
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
    }).replace(/[/,: ]/g, "-");

    const filename = `Comparative_Report_${timestamp}.xlsx`;
    XLSX.writeFile(workbook, filename);
  }

  // ELSE block for non-24-hour shift
  else {
    if (typeof XLSX === "undefined") {
      throw new Error("SheetJS (XLSX) library is required for this function.");
    }

    const formatDate = (date) => {
      return new Date(date).toLocaleString("en-GB", {
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true,
      });
    };

    const meterNames = data.map((item) => item.name);
    const rowCount = data[0]?.data?.length || 0;
    const headers = ["From Date", "To Date", ...meterNames, "Parameter"];
    const rows = [headers];
    const totals = {};
    meterNames.forEach((name) => (totals[name] = 0));

    for (let i = 0; i < rowCount; i++) {
      const intervalStart = data[0].data[i].intervalRange?.start;
      const intervalEnd = data[0].data[i].intervalRange?.end;

      const row = [
        formatDate(intervalStart),
        formatDate(intervalEnd),
      ];

      data.forEach((meter) => {
        const value = parseFloat(meter.data[i]?.value || 0);
        row.push(roundToTwo(value));
        totals[meter.name] += value;
      });

      row.push(selectedValues?.toString() || "");
      rows.push(row);
    }

    const totalRow = [
      "Total",
      "",
      ...meterNames.map((name) => roundToTwo(totals[name])),
      "",
    ];
    rows.push(totalRow);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(rows);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Interval Report");

    const now = new Date();
    const timestamp = now.toISOString().replace(/[-:T]/g, "_").split(".")[0];
    const filename = `Comparative_Report_${timestamp}.xlsx`;

    XLSX.writeFile(workbook, filename);
  }
};

  const handleCheckboxChange = (checked, value) => {
    setCheckedValue(checked ? value : null);
    setTime(!time);
    console.log(checked);
    console.log(value);

    if (checked) {
      setShift(value);
      handleTimeRangeChange(value);
    } else {
      setFromDateString(null);
      setToDateString(null);
    }
    console.log("Checked value:", checked ? value : "None");
  };

  const aggregationMap = {
    1: { value: "60min", label: "Last 60 Minutes" },
    2: { value: "8hours", label: "Last 8 Hours" },
    3: { value: "7days", label: "Last 7 Days" },
    4: { value: "30days", label: "Last 30 Days" },
    4: { value: "90days", label: "Last 90 Days" },
    5: { value: "24hours", label: "Last 24 Hours" },
  };
  console.log(checkedValue);
  console.log(time);
  console.log(data1);

  useEffect(() => {
     document.documentElement.style.setProperty("--date-ok-btn", color.themeConfig.colorPrimary);
     document.documentElement.style.setProperty("--date-now-btn", "#fff");
   }, [color]);

   const [showCalendar, setShowCalendar] = useState(false);
   const [value, setValue] = useState([null,null]);

  const today = dayjs();
   const startOfWeek = dayjs().weekday(0); // Sunday
   const endOfWeek = dayjs().weekday(6);   // Saturday
   const startOfLastWeek = dayjs().subtract(1, "week").weekday(0);
   const endOfLastWeek = dayjs().subtract(1, "week").weekday(6);
   const startOfMonth = dayjs().startOf("month");
   const endOfMonth = dayjs().endOf("month");
   const startOfLastMonth = dayjs().subtract(1, "month").startOf("month");
   const endOfLastMonth = dayjs().subtract(1, "month").endOf("month");
   
   const rangePresets = [
    //  { label: "Today", value: [today.startOf("day"), today.endOf("day")] },
    //  { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.subtract(1, "day").endOf("day")] },
     { label: "This Week", value: [startOfWeek, endOfWeek] },
     { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
     { label: "This Month", value: [startOfMonth, endOfMonth] },
     { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
     { label: "Last 7 Days", value: [dayjs().subtract(7, "day"), today] },
     { label: "Last 15 Days", value: [dayjs().subtract(15, "day"), today] },
     { label: "Last 30 Days", value: [dayjs().subtract(30, "day"), today] },
     { label: "Last 90 Days", value: [dayjs().subtract(90, "day"), today] },
   ];
   
  const handleDateChange = (value) => {
    if (!value) return;
    const diff = value[1]?.diff(value[0], "day");

    if (diff > MAX_DAYS) {
      alert("Date range cannot exceed 90 days");
      return;
    }
    
    if (value) {
      // const fromDate = value[0];
      // const toDate = value[1];
      const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
      const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");

      console.log([fromDate, toDate]);
      setValue([value[0], value[1]]);
      onChangeFromDate(fromDate);
      onChangeToDate(toDate);
    } else {
      // setDates(null);
    }
  };
  const handleChange = (val) => {
    if (!val) return;
    const diff = val[1]?.diff(val[0], "day");

    if (diff > MAX_DAYS) {
      alert("Date range cannot exceed 90 days");
      return;
    }

    setValue(val);
  };
  console.log(isdarkMode)

  return (
    <div
      id="chart"
      className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? "darkmode" : "whitemode"} `}
    >
      {/* {
          data1.length ==0 && !loadings && !loading &&
             <h4 className={`text-center text-[20px] mb-5 dark ${isdarkMode ? 'darkfont' : 'whitemode'}`}>COMPARATIVE REPORT</h4> 
         } */}

      <div className="flex justify-between items-center px-0 pb-3">
        <div className="text-3xl">
          <h4
            className={`text-center mb-0 dark ${isdarkMode ? "darkfont" : "whitemode"}`}
          >
            COMPARATIVE REPORT
          </h4>
        </div>
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
      </div>
      {
        data1.length == 0 && !loadings && !loading && (
          <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
        )
        // <div className="text-3xl">
        // <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
        // </div>
      }
      <Card
        className={`p-5 rounded-md dark border  ${!data1.length>0 ?'hidden':''} ${isdarkMode ? "darkmode " : `whitemode `} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        
        // style={{ position: "relative", overflow: "hidden", background:isdarkMode ? "" : color.themeConfig.colorPrimaryShade }}
        bordered={false}
      >
        {(loading || loadings) && (
          <>
            <Skeleton active paragraph={{ rows: 6 }} />
          </>
        )}

        <div
          ref={chartRef}
          className={`${(!loading || !loadings) && data1.length > 0 ? "min-h-[80vh]" : "h-0"}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}
        />
      </Card>
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            // valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            // nameKey={sectionId === 1 ? "sitename" : "department"}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
             selectedValues={converterGroupId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <SteamTreeSelectCustom
            label="Parameters:"
            data={parameter}
            idKey="parameterid" 
            nameKey="parametername"
            valueKey="parameterid"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            {/* {parameterLenght} */}
          </small>
          <CustomSelect
            label="Aggregation period:"
            options={aggeregationList}
            onSelect={handleChangeAggregation}
            valueKey="aggregationPeriodID"
            nameKey="aggregationPeriodName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {aggregationError}
          </small>
          <div className="mt-2 flex flex-col">
            {aggregationMap[aggregationTime] && (
              <div
                className={`custom-checkbox ml-[130px] ${isdarkMode ? "dark-theme" : "light-theme"} `}
              >
                <Checkbox
                  checked={
                    checkedValue === aggregationMap[aggregationTime].value
                  }
                  defaultChecked
                  onChange={(e) =>
                    handleCheckboxChange(
                      e.target.checked,
                      aggregationMap[aggregationTime].value
                    )
                  }
                >
                  {/* <p className={`${isdarkMode ? 'text-white' : 'text-black'}`}> */}
                  {aggregationMap[aggregationTime].label}
                  {/* </p> */}
                </Checkbox>
              </div>
            )}
            {/* <small className="text-red-500 font-bold ml-[150px] w-full">
              {toDateError}
            </small> */}
          </div>

          {!time && !checkedValue ? (
            <>
                           <div className="mt-2 flex">
                           <label className="pr-3 w-32 text-left">Date:</label>
                           
                           <RangePicker
      value={value}
      onChange={handleDateChange}
      popupClassName="custom-picker"
      presets={rangePresets}
      format="YYYY-MM-DD HH:mm:ss"
      showTime={{ format: "HH:mm:ss" }}
      className={`w-80 ml-0 shadow-lg rounded-3xl  ${
        isdarkMode
          ? "customRangePicker-dark  text-white"
          : "customRangePicker-light text-black"
      }`}
      panelRender={(originalPanel) => {
        if (!showCalendar) {
          return (
            <div
              className={`${
                isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
              } flex flex-col gap-1 p-2 w-44 rounded`}
            >
              {rangePresets.map((preset) => (
                <div
                  key={preset.label}
                  onClick={() => handleDateChange(preset.value)}
                  className={`cursor-pointer px-2 py-1 rounded ${
                    isdarkMode
                      ? "text-white hover:bg-gray-700"
                      : "text-black hover:bg-gray-200"
                  }`}
                >
                  {preset.label}
                </div>
              ))}
              <button
                onClick={() => setShowCalendar(true)}
                className={`mt-2 px-2 py-1 rounded  border text-center ${
                  isdarkMode
                    ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                    : "bg-white border-black text-black hover:bg-gray-200"
                }`}
              >
                Custom Dates
              </button>
            </div>
          );
        }
        return originalPanel;
      }}
      onOpenChange={(open) => {
        if (!open) setShowCalendar(false);
      }}
    />
      {/* <RangePicker
          presets={rangePresets}
          // showTime={{ format: "HH:mm:ss" }} // Enables time selection
          // format="YYYY-MM-DD "
          showTime={{ format: "HH:mm:ss" }}
          format="YYYY-MM-DD HH:mm:ss"
          onChange={handleDateChange}
          className={`${!isdarkMode? "customRangePicker-light":"customRangePicker-dark  "}    w-[300px] ml-2  border border-white `} 
        /> */}
    </div>
            </>
            // <>
              // <div className="mt-2 flex">
              //   <label className="pr-3 w-32 text-left">From Date:</label>
            //     <DatePicker
            //       value={fromDateObj}
            //       onChange={onChangeFromDate}
            //       className={`   ${isdarkMode ? "datebackground" : "whitemode"} w-80 `}
            //       dropdownClassName={isdarkMode ? "datedropdown" : "whitemode"}
            //       showTime={{ format: "HH:mm:ss" }}
            //       format="YYYY-MM-DD HH:mm:ss"
            //       popupClassName="custom-picker"
            //     />
            //   </div>
            //   <small className="text-red-500 font-bold ml-[150px]">
            //     {fromDateError}
            //   </small>
            //   <div className="mt-2 flex">
            //     <label className="pr-3 w-32 text-left">To Date:</label>
               
            //     <DatePicker
            //       value={toDateObj}
            //       onChange={onChangeToDate}
            //       className={`   ${isdarkMode ? "datebackground" : "whitemode"} w-80 `}
            //       dropdownClassName={isdarkMode ? "datedropdown" : "whitemode"}
            //       showTime={{ format: "HH:mm:ss" }}
            //       format="YYYY-MM-DD HH:mm:ss"
            //       popupClassName="custom-picker"
            //     />
            //   </div>
            //   <small className="text-red-500 font-bold ml-[150px]">
            //     {toDateError}
            //   </small>
            // </>
          ) : (
            ""
          )}
        </div>
        <div className="flex justify-center mt-4">
      
            <Button
              type={isdarkMode ? "" : "primary"}
              onClick={() => {
                handleSubmit();
              }}
            >
              Search
            </Button>
        </div>
      </CustomDrawer>
      <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
          .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
    </div>
  );
};

export default ComparitiveReport;
